import { TemplateList } from "~/libs/constants/TemplateList";
import type AuthorLocal from "~/libs/interfaces/AuthorLocal";

export const RedactionConfig: Record<TemplateList, Partial<AuthorLocal>[]> = {
  [TemplateList.POGGERS]: [
    {
      id: "julian-tran ",
      fullname: "Julian Tran",
      profession: "Poggers Emperor",
      biography: "Marketér extraordinaire a duchovní otec projektu Poggers, který kromě gamesek miluje cestování, pálivé jídlo a otužování. Svůj volný čas se snaží maximálně věnovat svému synovi a rodině, srdce mu však stále tepe pro ranní tiskovky a videoherní večírky, ve kterých si nezadá ani s teenagery.",
      email: "julian.tran@cncenter.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/asFejaMoz7DaOxSEI.jpeg"
    },
    {
      id: "branislav-kovacovic",
      fullname: "Branislav Kovačovic",
      profession: "Sales Jedi",
      biography: "Věčně mladý hráč her, který má více než desetileté zkušenosti s československým profesionálním esportem. Organizátor eventů, turnajů, první milionové mezinárodní ligy u nás a majitel esportové organizace. Ve volném čase organizuje turnaje během organizování turnajů.",
      email: "branislav.kovacovic@cncenter.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/asEPDsqEEeKCRszeg.jpeg"
    },
    {
      id: "jonas-macha",
      fullname: "Jonáš Mácha",
      profession: "CEO of Memes",
      biography: "Má psychické problémy z League of Legends, které si léčí prací s herní komunitou. Profík na soušly a obsah, který táhne. Naše logo mu připomíná vtipného červeného mužíka z vesmíru (nevíme co to znamená).",
      email: "jonas.macha@cncenter.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/asHeiJwZ5RzwqDQRu.jpeg"
    },
    {
      id: "jan-stary",
      fullname: "Jan Starý",
      profession: "Discord Architect",
      biography: "Ve dne prostý občan, v noci toxický spoluhráč s psychickými problémy v riftu. Když slunce svítí, je pravá ruka Head of Socials, jakmile zajde, stává se z něho nemilosrdný Discord mód. Jeho úkolem přes den je pomáhat bavit lidí, v noci trápit. Miluje jídlo a nesnáší sprchu. Je to hrdina či padouch? A ano, logo opravdu vypadá jako červený mužíček z vesmíru.",
      email: "redakce@poggers.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/aseOBWmiXDmEiUhPY.jpg"
    },
    {
      id: "ladislav-novak",
      fullname: "Ladislav Novák",
      profession: "Review Master",
      biography: "Recenzent, filozof, věčný optimista, milovník žen a dobrého vína. Svůj volný čas nejraději tráví při posezení s rodinou/přáteli a na výletech, ať už po Čechách nebo do zahraničí. Pasivní sportovec a nenapravitelný konzumente ledního hokeje a Formule 1. Řídí se heslem „když to máš, tak to ukaž“.",
      email: "novak.hr@email.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/asaGWOsMVjM3yUYUr.jpg"
    },
    {
      id: "vojtech-matusinsky",
      fullname: "Vojtěch Matušinský",
      profession: "The Tester",
      biography: "Recenzent a zapálený fanoušek sci-fi a historie. Baví ho hlavně strategie a RPG, ale nepohrdne ani kvalitní akční hrou. Vedle her se věnuje historickému šermu ze starověkého Říma a třicetileté války. Pokud zrovna nesedí u kompu a nepobíhá s mečem, možná ho zahlédnete v nějaké krčmě.",
      email: "vojtechmatusinsky@seznam.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/asKI7yEqyNuZQoOfe.jpg"
    },
    {
      id: "martin-havel",
      fullname: "Martin Havel",
      profession: "News Sniper",
      biography: "Pisálek i hráč od útlého věku, který nepohrdne žádným zajímavým soustem herních informací a miluje výzvy. Hltoun memů a referencí, jehož pokusy o popkulturní humor zůstávají v “normální” společnosti opětovány nechápavými pohledy. Následný žal z humoristického neúspěchu utápí v nadměrných porcích svého kulinářského umění, které se snaží stále zdokonalovat.",
      email: "haavel.martin@gmail.com",
      avatarUrl: "https://cncenter.codexcdn.net/assets/as1kX5VKw8BpTXVGp.png"
    },
    {
      id: "michael-tyser",
      fullname: "Michael Tyšer",
      profession: "The Shooter",
      biography: "Nadšenec do teorií a milovník edgy humoru, Shooter píše satirické články o čemkoliv, co ho zrovna zajímá. Ačkoliv se toho o něm moc neví, jeho lásku pro kočky a indie videohry jen tak nic nepřekoná. Ve volném čase pracuje na hudbě nebo shitpostuje na sítích.",
      email: "redakce@poggers.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/askrzqwptplMpJLQi.jpg"
    },
    {
      id: "marek-srandorozeny",
      fullname: "Marek Srandorozený",
      profession: "Sarcasm Genius",
      biography: "Satirický fejetonista bez bázně a hany, plešky a vany. Jako absolventa gymnázia a vysoké školy jej lze považovat za exkluzivní elitu národa. V útlém věku se zabýval a stal součástí tolika oborů, že jej nelze definovat jen slovy. V roli předsedy Institutu Aplikované Legrace je jeho primárním účelem zabývat se otázkami proč, jak, za kolik a komu.",
      email: "marek.srandorozeny@cncenter.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/as96T9Aky0TwLVJdc.jpg"
    },
    {
      id: "jakub-cihak",
      fullname: "Jakub Čihák",
      profession: "Cinematic Warlock",
      biography: "Profík za kamerou i monitorem. Pořád naivně věří, že hraní CSka je k něčemu dobré, i když to nikam reálně nevede. Při lose streaku se věnuje produkci videí (což je většina jeho času).",
      email: "redakce@poggers.cz",
      avatarUrl: "https://cncenter.codexcdn.net/assets/asHoS1hfh9oqQd3ED.jpg"
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    // {
    //   id: "materidouska",
    //   fullname: "Mateřídouška",
    //   email: "materidouska@materidouska.cz",
    //   website: "www.materidouska.cz",
    //   biography: "Ahoj, já jsem Mateřídouška a vítám Tě na mém webu. Pokud máš jakékoliv dotazy, neváhej se na mě obrátit.",
    //   avatarUrl: "/img/materidouska/avatars/avatar001.png"
    // },
    {
      id: "eva-pacova",
      fullname: "Eva Pácová",
      profession: "Pomocník Mateřídoušky",
      email: "materidouska@materidouska.cz",
      website: "www.materidouska.cz",
      facebook: "https://www.facebook.com/casopisMateridouska",
      instagram: "https://www.instagram.com/materidouska_casopis/",
      biography: "Ahoj, já jsem Eva, jsem další z pomocníků Mateřídoušky. Starám se o tento web a také připravuju podcast Adélka a hvězdy. Máš pro mě nějaký námět? Napiš mi, budu se těšit.",
      avatarUrl: "/img/materidouska/avatars/avatar002.png"
    },
    {
      id: "lucie-hromkova",
      fullname: "Lucie Hromková",
      profession: "Pomocník Mateřídoušky",
      email: "materidouska@materidouska.cz",
      website: "www.materidouska.cz",
      facebook: "https://www.facebook.com/casopisMateridouska",
      instagram: "https://www.instagram.com/materidouska_casopis/",
      biography: "Ahoj, já jsem Lucka a pomáhám Mateřídoušce s obchodem. Napiš mi, pokud máš zájem s námi spolupracovat.",
      avatarUrl: "/img/materidouska/avatars/avatar003.png"
    },
    {
      id: "zuzana-paveskova",
      fullname: "Zuzana Pavésková",
      profession: "Pomocník Mateřídoušky",
      email: "materidouska@materidouska.cz",
      website: "www.materidouska.cz",
      facebook: "https://www.facebook.com/casopisMateridouska",
      instagram: "https://www.instagram.com/materidouska_casopis/",
      biography: "Ahoj, já jsem Zuzana. Pomáhám časopisu Mateřídouška, aby Tě každý měsíc mohl potěšit ve schránce.",
      avatarUrl: "/img/materidouska/avatars/avatar004.png"
    },
  ],
  [TemplateList.HEYFOMO]: [],
};